import React from 'react';
import {NodeProps, useReactFlow} from 'reactflow';

import {RouterNodeAdapter} from 'processes/graph-builder-processes/processes-plugin/LogicNodeAdapters';
import {RouterNodeData} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/processFlowchartConfigEditorNodeTypes';
import {ReactFlowLockedContext} from 'ui-library/reactflow/LockedContext';
import {BenchlingNode} from 'ui-library/reactflow/nodes/BenchlingNode/BenchlingNode';

import {FlowchartEditorModeContext} from '../FlowchartEditorModeContext';
import {FlowchartFeaturesContext, isFlowchartFeatureEnabled} from '../FlowchartFeaturesContext';
import {
  FlowchartEditorMode,
  ProcessFlowchartEditorModeFeatureType,
} from '../ProcessFlowchartEditorModeConstants';
import createHeaderPropsForNode from './createHeaderPropsForNode';
import {getNodeAndRowStatusAndDescription} from './nodeUtils';
import ProcessFlowchartNodeToolbar from './ProcessFlowchartNodeToolbar';

const routerNodeAdapter = new RouterNodeAdapter();

export default function RouterNodeRenderer(props: NodeProps<RouterNodeData>): JSX.Element {
  const {data, xPos, yPos, id} = props;
  const reactFlowInstance = useReactFlow();
  const flowchartFeatures = FlowchartFeaturesContext.useContext();
  const isDeletable =
    isFlowchartFeatureEnabled(
      flowchartFeatures,
      ProcessFlowchartEditorModeFeatureType.ALLOW_NODE_ADD_DELETE
    ) && routerNodeAdapter.isDeletable();
  const locked = ReactFlowLockedContext.useContext() ?? false;
  const isExecutionViewer = FlowchartEditorModeContext.useContext() === FlowchartEditorMode.EXECUTION_VIEWER;
  const {onNodeHeaderClick, onNodeDelete, isDisabled} = data;

  const finalHeaderProps = createHeaderPropsForNode(
    {
      ...data,
      position: {x: xPos, y: yPos},
    },
    reactFlowInstance,
    {isExecutionViewer}
  );

  const {nodeStatus, nodeDescription} = getNodeAndRowStatusAndDescription(data.validationErrors);
  return (
    <div>
      <ProcessFlowchartNodeToolbar
        isLocked={locked || isDisabled}
        onNodeDelete={isDeletable ? onNodeDelete : undefined}
      />
      <div onClick={onNodeHeaderClick} style={{cursor: onNodeHeaderClick != null ? 'pointer' : 'default'}}>
        <BenchlingNode.Standard.Node
          isSelected={props.selected}
          isDisabled={isDisabled}
          status={nodeStatus}
          statusDescription={nodeDescription}
          headerProps={finalHeaderProps}
          width={data.nodeWidth}
          dataTestAttrs={{
            element: 'RouterNodeRenderer',
            key: id,
          }}
        />
      </div>
    </div>
  );
}
